import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router' ;
import { BaseComponent } from 'src/app/main/Components/base/base.component';
import { globalData } from 'src/app/main/Models/global.model';

import { ApiService } from '../../custom-material/Services/';
import { BuildingModel, BuildingTypeModel, UserModel } from '../../main/Models/';
import { toollist } from './building-form.tools';


@Component({
  selector: 'building-form',
  templateUrl: './t_building-form.component.html',
  styleUrls: ['./building-form.component.less']
})
export class BuildingFormComponent extends BaseComponent implements OnInit {


  origModel: BuildingModel;
  editModel: BuildingModel;

  set editModelBTid(id)
  {
    this.editModel.BuildingType = this.gd.buildingTypes.filter((bt)=>bt.id==id)[0];
  }
  get editModelBTid()
  {
    if(this.editModel.BuildingType==null) return 0;
    return this.editModel.BuildingType.id;
  }
  valid = true;



  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    public gd: globalData
    ) { 
      super(gd); 
      this.gd.toollist = toollist;
      this.gd.toolService = this;
      this.gd.showChooser = false;
      this.gd.headerTitle = 'Editer l\'établissement';
      this.gd.headerIcon = 'mod_edit';
    }

  ngOnInit() {
    this.loadBuildingTypes().then( () => {
      let id = +this.route.snapshot.params['building'];
      if(!id) {
        this.editModel = new BuildingModel({});
      } else {
        this.origModel = this.gd.findBuildingById(id);
        this.gd.headerBuilding = this.origModel;
        this.editModel = new BuildingModel(this.origModel);
      }
    });
  }

  loadBuildingTypes()
  { 
    return new Promise((resolve, reject) => {
      if(this.gd.buildingTypes.length>0) {
        resolve(true);
        return;
      }
      this.apiService.getFromServer('building-type')
        .then(s => s.subscribe((response:any) => {
          for (var i = response._embedded.building_type.length - 1; i >= 0; i--) {
            let bt = new BuildingTypeModel(response._embedded.building_type[i]);
            this.gd.buildingTypes.push(bt);
          }
          this.gd.buildingTypes.sort((bt1, bt2) => {return (bt1.name>bt2.name)?1:-1;});
          resolve(true);
        }) );
    });
  }


  save() {
    if(this.editModelBTid==undefined) {
      this.valid = false;
      return;
    }

    if(this.editModel.id>0) { //edition
      this.apiService.UpdateToServer('building', this.editModel.export())
        .then(s => s.subscribe((response:any) => {
          this.origModel.exchange(response);
          this.router.navigate(['buildings/'+this.origModel.id]);
      }));
    } else {                  //new
      this.editModel.User = this.apiService.connectedUser;
      this.apiService.SaveToServer('building', this.editModel.export())
        .then(s => s.subscribe((response:any) => {
          this.editModel = new BuildingModel(new BuildingModel(response));
          this.gd.buildings.push(this.editModel);
          this.gd.selectedBuildingsList.push(this.editModel.id);
          this.router.navigate(['buildings/'+this.editModel.id]);
      }));
    }
  }
  cancel()
  {
    if(this.editModel.id==undefined) {
      this.router.navigate(['buildings']);
    } else {
      this.router.navigate(['buildings/'+this.editModel.id]);
    }
  }

}
